import React, { useContext } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { GVarState } from '../StoreState/Gstate';

function Header() {
  let g = useContext(GVarState);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  return (
    <>
      {g.EndSearchInput && <img src="/images/back.svg" className='fixed top-4 left-2 z-20 w-8' onClick={() => {
        g.setDisplayEndPointResult(null)
        // searchInputHideAndShow()
        let params = {};
        searchParams.forEach((d, i) => {
          if (i == "v" || i == "m") params[i] = d;
        });
        navigate({
          pathname: "/",
          search: `?${createSearchParams(params)}`,
        })
        g.setStartAndEndPart(false)
        g.setEndSearchInput(null)
        g.setStartSearchInput(null)
        g.setStapeByStape(null)
        g.setpath([])
      }} />}
      <div className='newHeader'>
        <img src='/images/wovvmap.png' className='w-28' />
      </div>
    </>
  )
}

export default Header